import * as yup from "yup";
import { QuestionType } from "../CalculatorContext";

const questionSchema = yup.object({
  id: yup.number().required(),
  question: yup.string().required(),
  type: yup.mixed<QuestionType>().oneOf(Object.values(QuestionType)).required(),
  categories: yup.array().of(yup.string().required()).required(),
  priority: yup.number().required(),
  infoText: yup.string().required(),
  recommendation: yup.string().required(),
  source: yup.string().required(),
  impact: yup.string().required(),
});

export const questionsSchema = yup.object({
  heading: yup.string().required(),
  description: yup.string().required(),
  questions: yup.array().of(questionSchema).required(),
});
